import { render, staticRenderFns } from "./LockTransactions.vue?vue&type=template&id=52bf2fec&scoped=true&"
import script from "./LockTransactions.vue?vue&type=script&lang=ts&"
export * from "./LockTransactions.vue?vue&type=script&lang=ts&"
import style0 from "./LockTransactions.vue?vue&type=style&index=0&id=52bf2fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bf2fec",
  null
  
)

export default component.exports